import { render, staticRenderFns } from "./admin-engagement-bulk-messages.vue?vue&type=template&id=3b4a5036&scoped=true&"
import script from "./admin-engagement-bulk-messages.vue?vue&type=script&lang=js&"
export * from "./admin-engagement-bulk-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a5036",
  null
  
)

export default component.exports